<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Información de productos</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <form class="form-inline justify-content-sm-end" @submit="filterDataSubmit">
                <input
                  class="form-control form-control-sm rounded bright col-2"
                  placeholder="Producto"
                  v-model="filter.producto"
                  type="text"
                />
                <input
                  class="form-control form-control-sm rounded bright col-2"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData()"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  v-model="filter_activo"
                  class="form-control form-control-sm rounded bright"
                  @change="filterData"
                >
                  <option value>Todos</option>
                  <option value="false">Inactivos</option>
                  <option value="true">Activos</option>
                </select>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>SKU</th>
                <th>Nombre</th>
                <th class="text-center">Venta</th>
                <th class="text-center">Compra</th>
                <th class="text-center">Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="refreshPrecios(current.sku)"
              >
                <td>{{ current.sku }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div
                    v-if="current.permitir_venta"
                    class="status-pill green"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.permitir_venta"
                    class="status-pill red"
                    data-toggle="tooltip"
                  ></div>
                </td>
                <td class="text-center">
                  <div
                    v-if="current.permitir_compra"
                    class="status-pill green"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.permitir_compra"
                    class="status-pill red"
                    data-toggle="tooltip"
                  ></div>
                </td>
                <td class="text-center">
                  <div
                    v-if="current.activo"
                    class="status-pill green"
                    data-title="Activo"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.activo"
                    class="status-pill red"
                    data-title="Inactivo"
                    data-toggle="tooltip"
                  ></div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAddPrecios"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-xl modal-centered" role="document">
        <div style="width: 100%; max-width: 70%" class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div
              class="onboarding-content with-gradient"
              style="padding-right: 20px; padding-left: 20px; padding-bottom: 20px"
            >
              <div class="row">
                <div class="text-left col-12">
                  <h4 class="todo-content-header">
                    <i i class="os-icon os-icon-ui-83"></i
                    ><span>{{ current.nombre }} - {{ current.sku }}</span>
                  </h4>
                </div>
                <div
                  style="color: #1e76f9; font-size: 16px"
                  class="text-right col-12 font-weight-bold"
                >
                  <div v-for="detalle in currentBarras" v-bind:key="detalle.id">
                    {{ detalle.barra }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div>
                  <button
                    class="btn btn-md btn-outline-success"
                    @click="imprimir_barra()"
                  >
                    <i class="fa fa-barcode"></i>&nbsp; Imprimir Barra
                  </button>
                </div>
                &nbsp;
                <div>
                  <button
                    class="btn btn-md btn-outline-success"
                    @click="imprimir_hablador()"
                  >
                    <i class="fa fa-barcode"></i>&nbsp;
                    <span>Imprimir Hablador</span>
                  </button>
                </div>
                &nbsp;
                <div>
                  <button class="btn btn-md btn-dark" @click="verKardex()">
                    <i class="fa fa-list-ol"></i>&nbsp;
                    <span>Kardex</span>
                  </button>
                </div>
              </div>
              <br />
              <br />
              <nav class="col-12">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    class="col col-sm-1 nav-item nav-link active"
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    >General</a
                  >
                  <a
                    v-if="current.lista_precios"
                    class="col col-sm-3 nav-item nav-link text-center"
                    id="config-tab"
                    data-toggle="tab"
                    href="#config"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Configuración e inventario</a
                  >
                  <a
                    v-if="current.productolote_set"
                    class="nav-item nav-link"
                    id="unidad-tab"
                    data-toggle="tab"
                    href="#unidad"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Uds. Medidas</a
                  >
                  <a
                    v-if="current.productolote_set"
                    class="nav-item nav-link"
                    id="proveedores-tab"
                    data-toggle="tab"
                    href="#proveedores"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Proveedores</a
                  >

                  <a
                    v-if="current.productolote_set"
                    class="col col-sm-1 nav-item nav-link"
                    id="Contable-tab"
                    data-toggle="tab"
                    href="#precios"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Precios</a
                  >
                </div>
              </nav>

              <div class="tab-content element-box" id="nav-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Código del fabricante</label>
                        <input
                          v-on:keyup.enter="guardar"
                          v-model="current.codigo_fabricante"
                          :disabled="true"
                          class="form-control"
                          placeholder="Código del Fabricante"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Código original</label>
                        <input
                          :disabled="true"
                          v-on:keyup.enter="guardar"
                          v-model="current.codigo_original"
                          class="form-control"
                          placeholder="Código original"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-sm-3 text-left">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            checked
                            class="form-check-input"
                            name="optionsRadios"
                            v-model="current.activo"
                            type="radio"
                            value="true"
                          />Activo
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.activo"
                            name="optionsRadios"
                            type="radio"
                            value="false"
                          />Inactivo
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-3 text-left">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            checked
                            class="form-check-input"
                            v-model="current.consumible"
                            type="checkbox"
                            value="false"
                          />Consumible
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.peso"
                            type="checkbox"
                            value="false"
                          />Peso
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-3 text-left">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.es_servicio"
                            type="checkbox"
                            value="false"
                          />¿Es Servicio?
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.es_activo_fijo"
                            type="checkbox"
                            value="false"
                          />¿Es activo fijo?
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-3 text-left">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.permitir_multiplicador"
                            type="checkbox"
                            value="false"
                          />Permitir Multiplicador " * "
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="config"
                  role="tabpanel"
                  aria-labelledby="config-tab"
                >
                  <ProductoTiendaTableComponent
                    :current="current"
                    :filtrartienda="current.lista_precios.codigo"
                  />
                </div>
                <div
                  class="tab-pane fade"
                  id="unidad"
                  role="tabpanel"
                  aria-labelledby="unidad-tab"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <h5 class="text-success font-weight-bold">
                        Configuración de Unidades de Medidas
                      </h5>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <div class="form-group">
                        <label class="font-weight-bold" style="font-size: 15px"
                          >Unidad de medida de compra</label
                        >
                        <br />
                        <table class="table">
                          <tr>
                            <th>Nombre</th>
                            <th>Cantidad</th>
                          </tr>
                          <tr>
                            <td>
                              {{ current.unidad_medida_compra_obj.nombre }}
                            </td>
                            <td>
                              {{ current.unidad_medida_compra_obj.cantidad_unidades }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-6">
                      <div class="form-group">
                        <label class="font-weight-bold" style="font-size: 15px"
                          >Unidad de medida de solicitud</label
                        >
                        <table class="table">
                          <tr>
                            <th>Nombre</th>
                            <th>Cantidad</th>
                          </tr>
                          <tr>
                            <td>
                              {{ current.unidad_medida_solicitud_obj.nombre }}
                            </td>
                            <td>
                              {{ current.unidad_medida_solicitud_obj.cantidad_unidades }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <h5 class="text-success font-weight-bold">
                        Listado de Unidades de Medida para Venta
                      </h5>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead class="table-primary">
                            <tr>
                              <th class="text-center">Nombre</th>
                              <th class="text-center">Unidades</th>
                              <th class="text-center">Revision al facturar</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="det in current.productounidadmedida_set"
                              v-bind:key="det.id"
                            >
                              <td class="text-left">
                                {{ det.unidad_medida.nombre }}
                              </td>
                              <td class="text-center">
                                {{ det.unidad_medida.cantidad_unidades }}
                              </td>
                              <td class="text-center">
                                <span
                                  v-bind:class="{
                                    'status-pill green':
                                      det.revision_al_despachar == true,
                                    'status-pill red': det.revision_al_despachar == false,
                                  }"
                                ></span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="contable"
                  role="tabpanel"
                  aria-labelledby="contable-tab"
                ></div>
                <div
                  class="tab-pane fade"
                  id="proveedores"
                  role="tabpanel"
                  aria-labelledby="proveedores-tab"
                >
                  <div class="table-responsive">
                    <!-------------------- Tabla de REsultados -------------------->
                    <table v-if="dataproveedores && dataproveedores[0]" class="table">
                      <thead>
                        <tr>
                          <th scope="col">Código</th>
                          <th scope="col">Nombre</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="det in dataproveedores" v-bind:key="det.id">
                          <td v-if="det.proveedor_obj" scope="col">
                            {{ det.proveedor_obj.codigo }}
                          </td>
                          <td>{{ det.proveedor_obj.nombre }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="precios"
                  role="tabpanel"
                  aria-labelledby="precios-tab"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Tienda</th>
                            <th class="text-center">Lista de Precio</th>
                            <th class="text-center">Unidad de Medidad</th>
                            <th class="text-center">Cant. unidades</th>
                            <th class="text-center">Precio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="detalle in precios" v-bind:key="detalle.id">
                            <td>
                              {{ current.lista_precios.codigo }} -
                              {{ current.lista_precios.nombre }}
                            </td>
                            <td class="text-center">
                              {{ detalle.lista_precio.nombre }}
                            </td>
                            <td class="text-center">
                              {{ detalle.unidad_medida.nombre }}
                            </td>
                            <td class="text-center">
                              {{ detalle.unidad_medida.cantidad_unidades }}
                            </td>
                            <td class="text-center">{{ detalle.precio }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <small
                  v-if="current.errors && current.errors.non_field_errors"
                  class="form-text text-danger"
                  >{{ current.errors.non_field_errors[0] }}</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import DynamicService from "../../../services/commons/DynamicService";
import ProductoProveedorService from "@/services/catalogos/ProductoProveedorService";
import ProductoTiendaTableComponent from "@/components/cat/precios/ProductoTiendaTableComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    ProductoTiendaTableComponent,
  },
  data() {
    return {
      filter: {
        producto: "",
      },
      mostrarRefresh: false,
      current: {
        unidad_medida_compra_obj: "",
        unidad_medida_solicitud_obj: "",
        estado: "A",
        unidad_medida: "",
        errors: {},
        unidad_medida: "",
        sku: null,
        unidad_medida_compra: "",
        unidad_medida_solicitud: null,
        productolote_set: "",
        permitir_compra: false,
        consumible: false,
        permitir_venta: false,
        pk: null,
        lista_precios: "",
      },
      precios: {},
      det: {
        proveedor_obj: "",
        id: "",
      },
      detalle: {},
      currentBarras: {},
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      dataproveedores: [],
    };
  },
  mounted() {
    this.refreshData();
    if (this.$route.params.sku) {
      this.refreshPrecios(this.$route.params.sku);
    }
  },
  methods: {
    refreshProveedores(params) {
      let self = this;
      if (params == null) {
        params = {};
      }
      let _params = Object.assign(params, {
        producto: this.current.sku,
        quitar_paginacion: "true",
      });
      ProductoProveedorService.fetch(_params).then((res) => {
        self.dataproveedores = res.data;
      });
    },
    resfreshListaPrecioMyUser() {
      let self = this;
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
      })
        .then((response) => {
          this.current.lista_precios = response.data.results;
          if (this.current.lista_precios && this.current.lista_precios[0]) {
            this.current.lista_precios = this.current.lista_precios[0].tienda;
            this.refreshPreciosPorLista();
          } else {
            Notifications.alert.error(
              "Información",
              "El usuario " +
                localStorage.getItem("name") +
                " no esta asignado a ninguna tienda, asignelo antes."
            );
          }
        })
        .catch((error) => {
          Notifications.alert.error(
            "Información",
            "El usuario " +
              localStorage.getItem("name") +
              " no esta asignado a ninguna tienda, asignelo antes."
          );
        });
    },
    refreshPreciosPorLista() {
      let self = this;
      console.log(this.current.lista_precios.lista_precioz);
      DynamicService.fetch("cat", "precios", {
        producto: this.current.sku,
        lista_precio: this.current.lista_precios.lista_precio,
        estatus: true,
      }).then((response) => {
        $("#modalAddPrecios").modal("show");
        self.precios = response.data.results;
      });
    },
    refreshProductoBarra() {
      DynamicService.fetch("cat", "producto-barra", {
        producto: this.current.sku,
      }).then((response) => {
        this.currentBarras = response.data.results;
      });
    },
    refreshPrecios(current) {
      let self = this;
      ProductosService.getById(current).then((response) => {
        self.current = response.data;
        self.refreshProductoBarra();
        self.resfreshListaPrecioMyUser();
        self.refreshProveedores();
      });
    },
    imprimir_barra() {
      let self = this;
      ProductosService.imprimir_barra(self.current.sku)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    imprimir_hablador() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/HabladorPorTienda.jrxml&tienda=${self.current.lista_precios.codigo}&sku=${self.current.sku}`
      );
    },
    verKardex() {
      let self = this;
      $("#modalAddPrecios").modal("hide");
      self.$router.push({
        name: "inventario-reportes-kardex",
        params: {
          sku: self.current.sku,
          tienda: self.current.lista_precios.codigo,
        },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
        sku: this.filter.producto,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.filter.producto = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "productos", params)
        .then((res) => {
          self.data = res.data;
        })
        .catch((error) => {
          self.data = [];
        });
    },
    showModalAddPrecios() {
      let self = this;
      $("#modalAddPrecios").modal();
    },
  },
};
</script>
